import type { FieldGroup, FormField } from '@/types/formSchema';

/**
 * Determine if a field should be visible based on its hide-when conditions
 * and inferred/hidden state. Used by FieldGroupRenderer to filter visible fields.
 */
export function isFieldVisible(field: FormField, formData: Record<string, unknown>): boolean {
  if (field.inferredFrom || field.hidden) return false;
  if (!field.hideWhenField) return true;

  const val = String(formData[field.hideWhenField] ?? '');
  // hideWhenValues (array) takes precedence over deprecated hideWhenValue (string)
  if (field.hideWhenValues?.length) return !field.hideWhenValues.includes(val);
  if (field.hideWhenValue && val === field.hideWhenValue) return false;
  return true;
}

/**
 * True when a group has fields and every one of them is `hidden`, i.e. rendering it would
 * leave an empty section. A group with no fields at all is not "all hidden".
 */
export function hasOnlyHiddenFields(group: Pick<FieldGroup, 'fields'>): boolean {
  return group.fields.length > 0 && group.fields.every(field => field.hidden);
}
